var render = function () {
  var _vm$selected;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-btn-toggle', {
    staticClass: "ma-n2 ma-lg-n4",
    attrs: {
      "value": (_vm$selected = _vm.selected) === null || _vm$selected === void 0 ? void 0 : _vm$selected.value,
      "color": "primary"
    }
  }, _vm._l(_vm.items, function (_ref) {
    var data = _ref.data,
      value = _ref.value;
    return _c('v-btn', _vm._b({
      key: value,
      staticClass: "ma-2 ma-lg-4 min-w-80px min-w-lg-120px",
      attrs: {
        "outlined": "",
        "small": ""
      },
      on: {
        "click": function click($event) {
          (_vm.application = Object.assign({}, data)) && _vm.emit();
        }
      }
    }, 'v-btn', {
      value: value
    }, false), [_vm._v(" " + _vm._s(value))]);
  }), 1);
}
var staticRenderFns = []

export { render, staticRenderFns }